import React from "react";

import LogsList from "../features/videos/LogsList";
import RobotNavigation from "../features/robot/RobotNavigation";

function NovEyeLogsPage() {
  return (
    <>
      <RobotNavigation />
      <LogsList />
    </>
  );
}

export default NovEyeLogsPage;
